// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1NWM3","footer":"ModalError_footer__2Xtf1"};